import LessonComponent from '@/components/pages/lessons/index.vue'
import Lesson from '@/components/pages/lessons/Detail.vue'
import ClassRecordInput from '@/components/pages/lessons/classRecord/Input.vue'
import Preparation from '@/components/pages/lessons/Preparation.vue'
import FinalReviewSheet from '@/components/pages/lessons/finalReviewSheet/Input.vue'

export default {
  path: '/lessons',
  name: 'LessonsRouter',
  component: LessonComponent,
  children: [
    {
      path: '/lessons/:lessonId',
      component: Lesson,
      name: 'LessonDetails',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
    },
    {
      path: '/lessons/:lessonId/classRecord/edit',
      component: ClassRecordInput,
      name: 'ClassRecordEdit',
      meta: {
        acceptRoles: ['senior', 'tutor'],
      },
    },
    {
      path: '/lessons/:lessonId/preparation',
      component: Preparation,
      name: 'Preparation',
      meta: {
        acceptRoles: ['senior', 'tutor'],
      },
    },
    {
      path: '/lessons/:lessonId/finalReviewSheet/edit',
      component: FinalReviewSheet,
      name: 'FinalReviewSheetEdit',
      meta: {
        acceptRoles: ['senior', 'tutor'],
      },
    },
  ],
}
